import { lazy } from "react";

export const DesktopSearchBarV2 = lazy(() =>
    import("./DesktopResultsSearchV2").then((m) => ({
        default: m.DesktopSearchBarV2,
    })),
);
export const DesktopFilterChipsV2 = lazy(() =>
    import("./DesktopResultsSearchV2").then((m) => ({
        default: m.DesktopFilterChipsV2,
    })),
);
export const MobileResultsSearchV2 = lazy(() =>
    import("./MobileResultsSearchV2").then((m) => ({
        default: m.MobileResultsSearchV2,
    })),
);
